export default "__VITE_ASSET__dzUEl01k__"